/* Small rounded pill used everywhere for status, type, count indicators.
   `cls` carries the per-status color classes (bg + text + ring) so a single
   component handles all the palette variations. */
export function Badge({ children, cls }) {
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${cls}`}
    >
      {children}
    </span>
  );
}
